module.exports = __webpack_public_path__ + "img/bg_function06_1_d.73ccd6a3.png";